import { Component, OnInit, ViewChild } from '@angular/core';
import { ApiService } from '../../../services/main/api.service';
import { NgbModal, ModalDismissReasons, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Storage } from '@ionic/storage';
import { Router, ActivatedRoute } from '@angular/router';
import { Global } from '../../../services/global';
import { BaseCrudComponent } from '../../base-crud/base-crud.component';
import { TranslateService } from '@ngx-translate/core';
import { Observable, BehaviorSubject, of, throwError, from } from 'rxjs';
import { mergeMap, catchError, timeout, retry } from 'rxjs/operators';
import { ExportAsService, ExportAsConfig } from 'ngx-export-as';
import * as moment from 'moment-timezone';

import { LazyLoadEvent } from 'primeng/api';
import { SelectItem } from 'primeng/api';
import {MessageService} from 'primeng/api';

import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

@Component({
  selector: 'app-portfolioanalysis',
  templateUrl: './portfolioanalysis.component.html',
  styleUrls: ['./portfolioanalysis.component.css']
})
export class PortfolioanalysisComponent extends BaseCrudComponent {

	exportAsConfig: ExportAsConfig = {
        type: 'xlsx',
        elementIdOrContent: 'exportable'
    };

  	translations:any;
	header:any;
	momentjs: any = moment;
    curr_date:any;
    today:any;
    dstart:any;
    dend:any;
    zones:any;
    totals:any;
    kpis:any;

    frozenCols:any;

	constructor(
	    srv: ApiService,
	    modalService: NgbModal,
	    storage: Storage,
  		router: Router,
  		private route: ActivatedRoute,
        public translate: TranslateService,
        private exportAsService: ExportAsService
	  ) {
	    super(srv, modalService, storage, router);
	    this.read_url = 'ReportPortfolioAnalysis/Post';
        this.header = {};
        this.zones = [];
        this.rows = [];
        this.totals = [];
        this.kpis = {};

        this.frozenCols = [
            { field: 'nombreCliente', header: 'CLIENTE', sortable:true, sortfield:'nombreCliente', styleC:{'text-align':'center'}, width:{'width.px': 350}, isColor:false, pre:'', pos:'', total:''}
        ];
    }

    ngOnInit() {
        /*this.curr_date = this.momentjs().tz('America/Guayaquil').format('YYYY-MM-DD');
        this.today = this.momentjs().tz('America/Guayaquil').format('YYYY-MM-DD');
        this.f_datefrom = this.curr_date;*/
        this.curr_date = this.momentjs().tz('America/Guayaquil').format('YYYY-MM');
        this.today = this.momentjs().tz('America/Guayaquil').format('YYYY-MM-DD');
        this.f_datefrom = this.curr_date;

    	this.translate.getTranslation(this.translate.currentLang)
        .subscribe((translations) => {
              this.translations = translations;
              super.ngOnInit();
              this.getList();
        });

        this.getZonesData().subscribe(x => {
            if(x != false){
                this.zones = x;
            }
        });
    }

    clearData(){
        this.header = {};
        this.rows = [];
        this.totals = [];
        this.kpis = {};
    }

    public getList(){
        var qst = this.read_url;
        var obj:any;
        //this.f_datefrom = '2020-10';
        this.clearData();

        obj = {
            Zone: null,
            Date: this.f_datefrom + '-01'
        }

        if( (this.f_custom1 != null) && (this.f_custom1 != 'null') ){
        	obj.Zone = this.f_custom1;
        }

        this.loadingList = true;
        //console.log(obj);

        this.srv.postCall(qst, obj).subscribe(x => {
        	this.loadingList = false;

            if(x.status){
                var rs = x.data;
                //console.log(rs);
                this.header = rs.header;
                this.totals = rs.detail.totals;
                this.rows = rs.detail.portfolioAnalysis;
                this.kpis = rs.summary;

                this.rows.forEach(r => {
                    let checker = parseFloat(r.cumplimiento.replace(/,/g, ''));
                	if(checker <= 80){
                		//red
                		r.varcolor = '#ff0000';
                        r.varcolorFont = '#c8c8c8';
                		r.varcolorClass = 'orangered';
                	}
                	else if(checker > 95){
                		//green
                		r.varcolor = '#adff2f';
                        r.varcolorFont = '#000';
                		r.varcolorClass = 'greenyellow';
                	}
                	else{
                		//yellow
                		r.varcolor = '#ffff00';
                        r.varcolorFont = '#000';
                		r.varcolorClass = 'yellow';
                	}

                    r.sort_cartera = parseFloat(r.carteraVencida.replace(/,/g, ''));
                });
            }
        });
    }

    public getZonesData(){
        var par_url = 'ZoneBP/ListByUser';

        return this.srv.getCall(par_url).pipe(
                    mergeMap(data => {
                        let mydata:any = {status: false, data: [], message: ''};
                        mydata = data;
                        //console.log(data);
                        
                        if( mydata.status ){
                          return of(mydata.data);
                        }
                        else{
                          return of(false);
                        }
                      }),
                      //timeout(MAX_TIME),
                      catchError(data => {return of(false)})
                );
    }

    exportReport(){
        this.exportAsService.save(this.exportAsConfig, 'vend_cartera_'+this.curr_date).subscribe(() => {
          // save started
        });
    }


}
